import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./GlitchTheme.css";
import GalaxyBackground from "./GalaxyBackground";
import imgCDFront from "./assets/wonder² cd.png";
import imgCDBack from "./assets/wonder² - cd atrás.png";
import moletomW2 from "./assets/moletomw2.png";
import moletomW3 from "./assets/moletomw3.png";

interface ProductDetail {
  id: number;
  sku: string;
  name: string;
  price: number;
  priceFormatted: string;
  tag: string;
  tagVariant?: "default" | "limited" | "featured" | "soldout";
  stock: string;
  stockLimit?: number;
  image?: string;
  images?: string[];
  preOrder?: boolean;
  unavailable?: boolean;
  includes: string[];
  description: string;
}

const PRODUCTS_DETAIL: Record<string, ProductDetail> = {
  "W2-CD-STD": {
    id: 10,
    sku: "W2-CD-STD",
    name: "Wonder² | Standard Edition (CD)",
    price: 35,
    priceFormatted: "R$ 35,00",
    tag: "EM BREVE",
    tagVariant: "soldout",
    stock: "EM BREVE",
    image: imgCDFront,
    images: [imgCDFront, imgCDBack],
    unavailable: true,
    description:
      "A edição essencial do Wonder². Um CD físico com tudo que você precisa pra ouvir o álbum do jeito que foi pensado.",
    includes: [
      "CD-R gravado e impresso;",
      "Box acrílico transparente;",
      "Encarte colecionável 8 páginas com letras completas e fotos inéditas;",
      "Lacre oficial.",
    ],
  },
  "W2-CD-SGN": {
    id: 11,
    sku: "W2-CD-SGN",
    name: "Wonder² | Standard Signed Edition (CD)",
    price: 40,
    priceFormatted: "R$ 40,00",
    tag: "PRÉ-VENDA",
    tagVariant: "featured",
    stock: "PRÉ-VENDA",
    stockLimit: 50,
    image: imgCDFront,
    images: [imgCDFront, imgCDBack],
    preOrder: true,
    description:
      "Tudo do Standard, mais a assinatura do Eduardo Bertozzi no encarte e uma carta escrita especialmente pra você. Limitado a 50 unidades.",
    includes: [
      "CD-R gravado e impresso;",
      "Box acrílico transparente;",
      "Encarte colecionável 8 páginas com letras completas e fotos inéditas;",
      "Assinatura no encarte;",
      "Carta manuscrita exclusiva;",
      "Lacre oficial.",
    ],
  },
  "W2-CD-CCE": {
    id: 12,
    sku: "W2-CD-CCE",
    name: "COTTON CANDY EDITION — wonder²",
    price: 55,
    priceFormatted: "R$ 55,00",
    tag: "LIMITED · 20 UN",
    tagVariant: "limited",
    stock: "LIMITADO",
    stockLimit: 20,
    image: imgCDFront,
    preOrder: true,
    description:
      "O lado doce do Wonder². Embalagem premium em Digipack com estética rosa e azul algodão doce, poster holográfico, carta exclusiva e foto estilo polaroid. Apenas 20 unidades.",
    includes: [
      "CD-R gravado e impresso",
      "Digipack premium 2 painéis com estética Cotton Candy",
      "Encarte colecionável 8 páginas personalizado",
      "Poster 24x36 exclusivo",
      "Carta manuscrita Cotton Candy Edition",
      "Foto polaroid exclusiva",
      "Lacre oficial",
    ],
  },
  "W2-CD-GKE": {
    id: 13,
    sku: "W2-CD-GKE",
    name: "GOLDEN KITE EDITION — wonder²",
    price: 55,
    priceFormatted: "R$ 55,00",
    tag: "LIMITED · 20 UN",
    tagVariant: "limited",
    stock: "LIMITADO",
    stockLimit: 20,
    image: imgCDFront,
    preOrder: true,
    description:
      "O lado profundo do Wonder². Embalagem premium em Digipack com estética roxa e dourada, poster holográfico, carta exclusiva e foto estilo polaroid. Apenas 20 unidades.",
    includes: [
      "CD-R gravado e impresso",
      "Digipack premium 2 painéis com estética Golden Kite",
      "Encarte colecionável 8 páginas personalizado",
      "Poster 24x36 exclusivo",
      "Carta manuscrita Golden Kite Edition",
      "Foto polaroid exclusiva",
      "Lacre oficial",
    ],
  },
  "W2-MOL-GAL": {
    id: 14,
    sku: "W2-MOL-GAL",
    name: "MOLETOM GALÁXIA — wonder²",
    price: 200,
    priceFormatted: "R$ 200,00",
    tag: "EM BREVE",
    tagVariant: "soldout",
    stock: "EM BREVE",
    image: moletomW2,
    unavailable: true,
    description: "Em breve. Fique de olho.",
    includes: [],
  },
  "W2-MOL-TIG": {
    id: 15,
    sku: "W2-MOL-TIG",
    name: "MOLETOM TIGRE — wonder²",
    price: 200,
    priceFormatted: "R$ 200,00",
    tag: "EM BREVE",
    tagVariant: "soldout",
    stock: "EM BREVE",
    image: moletomW3,
    unavailable: true,
    description: "Em breve. Fique de olho.",
    includes: [],
  },
};

interface ProductPageProps {
  cart: { id: number; quantity: number }[];
  onAddToCart: (product: ProductDetail) => void;
}

const ProductPage: React.FC<ProductPageProps> = ({ cart, onAddToCart }) => {
  const { sku } = useParams<{ sku: string }>();
  const navigate = useNavigate();
  const product = sku ? PRODUCTS_DETAIL[sku] : null;
  const [selectedImg, setSelectedImg] = useState(0);
  const [zoomed, setZoomed] = useState(false);
  const [backHover, setBackHover] = useState(false);

  if (!product) {
    return (
      <div className="wonder-page wonder-galaxy galaxy-subpage">
        <GalaxyBackground />
        <div
          className="galaxy-subpage-content"
          style={{
            background: "transparent",
            paddingTop: "8rem",
            textAlign: "center",
          }}
        >
          <p style={{ color: "#c87fff", fontFamily: "Space Mono, monospace" }}>
            &gt; PRODUTO NÃO ENCONTRADO.
          </p>
          <button
            onClick={() => navigate("/merch")}
            className="wonder-galaxy-btn"
            style={{ marginTop: "2rem" }}
          >
            <span>← VOLTAR À LOJA</span>
          </button>
        </div>
      </div>
    );
  }

  const images = product.images ?? (product.image ? [product.image] : []);
  const cartQty = cart.find((i) => i.id === product.id)?.quantity ?? 0;
  const isAtLimit =
    product.stockLimit !== undefined && cartQty >= product.stockLimit;
  const isUnavailable = product.unavailable;

  const tagColors: Record<string, string> = {
    featured: "#00f2ff",
    limited: "#d32f2f",
    soldout: "#d32f2f",
    default: "#39ff14",
  };

  return (
    <div className="wonder-page wonder-galaxy galaxy-subpage">
      <GalaxyBackground />

      {zoomed && (
        <div
          onClick={() => setZoomed(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(5,0,15,0.92)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "zoom-out",
            backdropFilter: "blur(8px)",
          }}
        >
          <img
            src={images[selectedImg]}
            alt={product.name}
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              objectFit: "contain",
              borderRadius: "4px",
              boxShadow: "0 0 60px rgba(180,80,255,0.3)",
            }}
          />
          <span
            style={{
              position: "absolute",
              top: "1.5rem",
              right: "2rem",
              color: "rgba(200,160,255,0.5)",
              fontFamily: "Space Mono, monospace",
              fontSize: "0.75rem",
              letterSpacing: "2px",
            }}
          >
            [ CLIQUE PARA FECHAR ]
          </span>
        </div>
      )}

      <div
        style={{
          background: "transparent",
          maxWidth: "900px",
          margin: "0 auto",
          padding: "7rem 2rem 4rem",
        }}
      >
        <button
          onClick={() => navigate("/merch")}
          onMouseEnter={() => setBackHover(true)}
          onMouseLeave={() => setBackHover(false)}
          style={{
            background: backHover ? "rgba(200,127,255,0.08)" : "transparent",
            border: "1px solid rgba(200,127,255,0.3)",
            color: backHover ? "#e0b8ff" : "rgba(200,160,255,0.5)",
            fontFamily: "Space Mono, monospace",
            fontSize: "0.75rem",
            cursor: "pointer",
            letterSpacing: "3px",
            marginBottom: "2.5rem",
            padding: "0.6rem 1.25rem",
            transition: "all 0.25s ease",
            boxShadow: backHover ? "0 0 15px rgba(200,127,255,0.2)" : "none",
            textTransform: "uppercase" as const,
          }}
        >
          ← LOJA
        </button>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "3rem",
            alignItems: "start",
          }}
        >
          {/* Galeria */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}
          >
            <div
              onClick={() => setZoomed(true)}
              style={{
                background: "rgba(20,5,40,0.6)",
                border: "1px solid rgba(180,100,255,0.15)",
                borderRadius: "4px",
                overflow: "hidden",
                aspectRatio: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "zoom-in",
                position: "relative",
              }}
            >
              {images[selectedImg] ? (
                <img
                  src={images[selectedImg]}
                  alt={product.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    opacity: isUnavailable ? 0.4 : 1,
                    transition: "transform 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "scale(1.04)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                />
              ) : (
                <span
                  style={{
                    color: "rgba(180,100,255,0.3)",
                    fontFamily: "Space Mono, monospace",
                    fontSize: "0.8rem",
                  }}
                >
                  [ W2_IMG ]
                </span>
              )}
              <span
                style={{
                  position: "absolute",
                  bottom: "0.75rem",
                  right: "0.75rem",
                  color: "rgba(200,160,255,0.4)",
                  fontFamily: "Space Mono, monospace",
                  fontSize: "0.6rem",
                  letterSpacing: "1px",
                }}
              >
                🔍 ZOOM
              </span>
            </div>

            {images.length > 1 && (
              <div style={{ display: "flex", gap: "0.5rem" }}>
                {images.map((img, i) => (
                  <div
                    key={i}
                    onClick={() => setSelectedImg(i)}
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "4px",
                      overflow: "hidden",
                      border: `1px solid ${
                        selectedImg === i ? "#c87fff" : "rgba(180,100,255,0.2)"
                      }`,
                      cursor: "pointer",
                      flexShrink: 0,
                      background: "rgba(20,5,40,0.6)",
                      transition: "border-color 0.2s",
                      boxShadow:
                        selectedImg === i
                          ? "0 0 10px rgba(200,127,255,0.3)"
                          : "none",
                    }}
                  >
                    <img
                      src={img}
                      alt={`${product.name} ${i === 0 ? "frente" : "atrás"}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        opacity: isUnavailable ? 0.4 : 1,
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Info */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.4rem",
              }}
            >
              <span
                style={{
                  background: tagColors[product.tagVariant ?? "default"],
                  color: product.tagVariant === "featured" ? "#050505" : "#fff",
                  fontSize: "0.65rem",
                  fontWeight: "bold",
                  letterSpacing: "1px",
                  padding: "0.3rem 0.8rem",
                  alignSelf: "flex-start",
                  fontFamily: "Space Mono, monospace",
                }}
              >
                {product.tag}
              </span>
              <span
                style={{
                  color: "rgba(180,100,255,0.3)",
                  fontSize: "0.65rem",
                  fontFamily: "Space Mono, monospace",
                  letterSpacing: "1px",
                }}
              >
                &gt; SKU:{product.sku}
              </span>
            </div>

            <h1
              style={{
                margin: 0,
                fontSize: "1.1rem",
                fontFamily: "Space Mono, monospace",
                color: "#e0e0e0",
                lineHeight: 1.5,
              }}
            >
              {product.name}
            </h1>

            <p
              style={{
                margin: 0,
                fontSize: "1.6rem",
                fontWeight: "bold",
                color: "#c87fff",
                fontFamily: "Space Mono, monospace",
                textShadow: "0 0 12px rgba(180,80,255,0.6)",
              }}
            >
              {product.priceFormatted}
            </p>

            <p
              style={{
                margin: 0,
                fontSize: "0.85rem",
                color: "rgba(230,200,255,0.7)",
                fontFamily: "Space Mono, monospace",
                lineHeight: 1.8,
              }}
            >
              {product.description}
            </p>

            {product.includes.length > 0 && (
              <div
                style={{
                  borderTop: "1px solid rgba(180,100,255,0.12)",
                  paddingTop: "1.25rem",
                }}
              >
                <p
                  style={{
                    margin: "0 0 0.75rem",
                    fontSize: "0.65rem",
                    letterSpacing: "3px",
                    color: "rgba(200,120,255,0.4)",
                    fontFamily: "Space Mono, monospace",
                  }}
                >
                  SYS.INCLUSO
                </p>
                <ul
                  style={{
                    margin: 0,
                    padding: 0,
                    listStyle: "none",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                  }}
                >
                  {product.includes.map((item, i) => (
                    <li
                      key={i}
                      style={{
                        fontSize: "0.8rem",
                        color: "rgba(230,200,255,0.65)",
                        fontFamily: "Space Mono, monospace",
                        display: "flex",
                        gap: "0.5rem",
                      }}
                    >
                      <span style={{ color: "#c87fff" }}>›</span> {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {product.preOrder && (
              <div
                style={{
                  background: "rgba(100,20,180,0.08)",
                  border: "1px solid rgba(200,127,255,0.2)",
                  padding: "1rem",
                  fontSize: "0.72rem",
                  color: "rgba(200,160,255,0.6)",
                  fontFamily: "Space Mono, monospace",
                  lineHeight: 1.7,
                }}
              >
                <span
                  style={{
                    color: "#c87fff",
                    display: "block",
                    marginBottom: "0.4rem",
                  }}
                >
                  ⟡ PRÉ-VENDA ATIVA
                </span>
                Produto será postado e enviado no dia do lançamento do álbum —{" "}
                <strong style={{ color: "rgba(200,160,255,0.8)" }}>
                  08.07.2026
                </strong>
                . Enquanto durarem os estoques.
              </div>
            )}

            <p
              style={{
                margin: 0,
                fontSize: "0.72rem",
                fontFamily: "Space Mono, monospace",
                color: "#555",
              }}
            >
              SYS.ESTOQUE:{" "}
              <span
                style={{
                  color: isUnavailable
                    ? "#d32f2f"
                    : product.stock === "LIMITADO"
                    ? "#c87fff"
                    : "#39ff14",
                }}
              >
                {product.stock}
                {product.stockLimit && !isUnavailable
                  ? ` · ${product.stockLimit} UN`
                  : ""}
              </span>
            </p>

            <button
              onClick={() =>
                !isUnavailable && !isAtLimit && onAddToCart(product)
              }
              disabled={isUnavailable || isAtLimit}
              style={{
                background:
                  isUnavailable || isAtLimit
                    ? "transparent"
                    : "rgba(140,60,220,0.08)",
                border: `1px solid ${
                  isUnavailable || isAtLimit
                    ? "rgba(211,47,47,0.4)"
                    : "rgba(200,120,255,0.5)"
                }`,
                color: isUnavailable || isAtLimit ? "#d32f2f" : "#e0b8ff",
                padding: "1rem 2rem",
                fontFamily: "Space Mono, monospace",
                fontSize: "0.85rem",
                letterSpacing: "3px",
                cursor: isUnavailable || isAtLimit ? "not-allowed" : "pointer",
                opacity: isUnavailable || isAtLimit ? 0.6 : 1,
                transition: "all 0.2s",
                textTransform: "uppercase" as const,
              }}
            >
              {isUnavailable
                ? "EM BREVE"
                : isAtLimit
                ? "LIMITE ATINGIDO"
                : "ADICIONAR AO CARRINHO"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPage;
export { PRODUCTS_DETAIL };
export type { ProductDetail };
